var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isReadOnlyUser
    ? _c(
        "md-button",
        {
          class: [
            "md-danger md-just-icon md-round",
            _vm.isDisabled ? "button-disabled" : "",
          ],
          attrs: { title: "Delete stop" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.handleDeleteStop(_vm.stopId)
            },
          },
        },
        [_c("md-icon", [_vm._v("delete")])],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }